import {Tone} from '@contentlab/api/avatars/types';

export interface ToneOption {
  id: Tone;
  localeLabelKey: string;
}

export const TONE_OPTIONS: ToneOption[] = [
  {id: Tone.Friendly, localeLabelKey: 'Friendly'},
  {id: Tone.Expert, localeLabelKey: 'Expert'},
  {id: Tone.Hype, localeLabelKey: 'Hype'},
  {id: Tone.Calm, localeLabelKey: 'Calm'},
  {id: Tone.Playful, localeLabelKey: 'Playful'},
  {id: Tone.Serious, localeLabelKey: 'Serious'},
];
